import { useState } from 'react';

/** Whether a locked options section is open for editing. It starts locked every time the dialog opens. */
export const useLockedOptionsSectionController = () => {
  const [editing, setEditing] = useState(false);
  return {
    editing,
    handleEdit: () => setEditing(true),
    handleDoneEditing: () => setEditing(false),
  };
};
